import http from '@core/fetch'

export default {
  //删除工作人员
  delManage: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/delManage',
      {
        body
      }
    ),

  //获取商家是否开通海草名片小程序
  cardStatus: body =>
    http('/hms/hljBusinessCard/appApi/admin/localServerMerchant/cardStatus', {
      body
    }),

  //开通海草名片小程序
  openCard: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/openCard',
      { body }
    ),

  //海草名片信息
  merchantCardInfo: () =>
    http(
      '/hms/hljBusinessCard/appApi/admin/localServerMerchant/merchantCardInfo '
    ),

  //更改客服账号管理员状态
  adminStatus: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/adminStatus',
      {
        body
      }
    ),
  //获取员工二维码
  getUserCodeUrl: body =>
    http(
      '/hms/businessCard/admin/localServerMerchant/businessCard/userShareQrCode',
      { body }
    ),
  //获取图集列表
  getPhotoList: body =>
    http('/hms/businessCard/admin/localServerMerchant/businessCard/photoList', {
      body
    }),
  //删除图集
  delPhoto: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/delPhoto',
      { body }
    ),

  //新建图集
  addPhoto: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/addPhoto',
      { body }
    ),

  //编辑图集
  editPhoto: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/editPhoto',
      { body }
    ),

  //图集详情
  photoSetDetail: body =>
    http(
      '/hms/businessCard/admin/localServerMerchant/businessCard/photoSetDetail',
      { body }
    ),
  //简化版商家工作人员列表
  manageSimpleList: () =>
    http(
      '/hms/businessCard/admin/localServerMerchant/businessCard/manageSimpleList'
    ),
  //图集分享信息
  photoShareDetail: body =>
    http(
      '/hms/businessCard/admin/localServerMerchant/businessCard/photoShareDetail',
      { body }
    ),
  //更新图集分享信息
  editPhotoShare: body =>
    http.post(
      '/hms/businessCard/admin/localServerMerchant/businessCard/editPhotoShare',
      { body }
    ),
  //员工号获取商家信息
  shareInfoByUser: body =>
    http(
      '/hms/businessCard/admin/localServerMerchant/businessCard/shareInfoByUser',
      { body }
    )
}
